var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.485,
    height: 34.485,
    viewBox: "0 0 34.485 34.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-280.257 -937.257)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 26,
    y2: 26,
    transform: "translate(284.5 941.5)",
    fill: "none",
    stroke: "#171a20",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y2: 26,
    transform: "translate(284.5 941.5)",
    fill: "none",
    stroke: "#171a20",
    strokeLinecap: "round",
    strokeWidth: 6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNo);
export default __webpack_public_path__ + "static/media/icon-no.ca598386.svg";
export { ForwardRef as ReactComponent };